import { accounts } from './accounts.endpoints';
import { assets } from './assets.endpoints';
import { cart } from './cart.endpoints';
import { commodityGroups } from './commodityGroups.endpoints';
import { imageClassificationModels } from './imageClassificationModels.endpoints';
import { infoMaterials } from './infoMaterials.endpoints';
import { storeSettings } from './storeSettings.endpoints';
import { user } from './user.endpoints';
import { session } from '@/lib/endpoints/storeManager/session.endpoints';

export const storeManagerEndpoints = {
    accounts,
    assets,
    cart,
    commodityGroups,
    imageClassificationModels,
    infoMaterials,
    session,
    storeSettings,
    user,
} as const;
